import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import { SPACE_INVADERS_ATLAS_FRAMES, SPACE_INVADERS_TEXTURE_KEYS } from './constants'

export const SpaceInvadersTextureLoader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (
    !scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)
  ) {
    scene.textures.addSpriteSheetFromAtlas(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (
    !scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)
  ) {
    scene.textures.addSpriteSheetFromAtlas(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (
    !scene.textures.getTextureKeys().includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_HIT_TRANSITION)
  ) {
    scene.textures.addSpriteSheetFromAtlas(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, {
      atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
      frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }

  if (
    !scene.textures
      .getTextureKeys()
      .includes(SPACE_INVADERS_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION)
  ) {
    scene.textures.addSpriteSheetFromAtlas(
      SPACE_INVADERS_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION,
      {
        atlas: SPACE_INVADERS_TEXTURE_KEYS.ATLAS,
        frame: SPACE_INVADERS_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION,
        frameWidth: LARGE_NUMBER_WIDTH,
        frameHeight: LARGE_NUMBER_HEIGHT,
      },
    )
  }
}
